import React from 'react';
import styled from 'styled-components';

import Row from 'components/Common/Row';
import Typography from 'kingpin/atoms/Typography';

const TextArea = styled.textarea<{ $isFilled: boolean }>`
  width: 100%;
  min-height: 96px;
  box-sizing: border-box;
  resize: vertical;
  padding: 12px 16px;
  border-radius: 10px;
  outline: none;
  font-family: Inter;
  font-size: 14px;
  line-height: 20px;
  color: var(--color-text-primary);
  border: 1px solid
    ${(props) =>
      props.$isFilled ? 'var(--color-info-v2)' : 'var(--color-border-primary)'};
  background-color: ${(props) =>
    props.$isFilled ? 'var(--color-bg-selected)' : 'var(--color-bg-primary)'};
  box-shadow: ${(props) =>
    props.$isFilled ? '0px 0px 0px 1px var(--color-info-v2)' : 'none'};
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;

  &::placeholder {
    color: var(--color-text-muted);
  }

  &:hover,
  &:focus {
    border-color: var(--color-info-v2);
  }

  &:focus {
    box-shadow: 0px 0px 0px 1px var(--color-info-v2);
  }
`;

// The note for an additional payment, styled to match the amount tiles and
// input above it. Required unless the payment carries a quick option's label.
const NoteInput = ({
  value,
  setValue,
  isRequired,
  testId,
}: {
  value: string;
  setValue: (value: string) => void;
  isRequired: boolean;
  testId: string;
}) => (
  <div style={{ marginBottom: 16 }}>
    <Row centerAlign spaceBetween style={{ marginBottom: 4 }}>
      <Typography.Body type={'Label'}>{'Note'}</Typography.Body>
      <Typography.Body type={'Body 12'} color={'var(--color-text-muted)'}>
        {isRequired ? 'Required' : 'Optional'}
      </Typography.Body>
    </Row>
    <TextArea
      value={value}
      onChange={(e) => setValue(e.target.value)}
      $isFilled={value.trim() !== ''}
      placeholder={
        'Why is this driver being recognised? e.g. Covered an extra load when a teammate was out'
      }
      data-testid={testId}
    />
  </div>
);

export default NoteInput;
